import type { EditorAPI } from '@/editorAPI';
import { getAppState } from './appState';

export const getOpenDataPanelOnStart = (editorAPI: EditorAPI) =>
  !!getAppState(editorAPI).openDataPanelOnStart;
